
export interface Person {
    photo: string
    name: string
    role: string
    affiliation: string
    email: string
}

export interface VolumeListEntry {
    slug: string
    cover: string
    label: string
    range: string
    month: string
}

export interface Article {
    title: string
    authors: string
    pdf: string
}

export interface ContactInfo {
    name: string
    role: string
    address: string
    emails: string[]
    phone: string
}

export interface HomeBlock {
    heading: string
    body: string
}

export interface FAQ {
    q: string
    a: string
}

export const EDITORIAL_BOARD: Person[]      = [
  {
    "photo": "/uploads/2026/02/Prof-Sangit-Ragi.jpeg",
    "name": "Prof. Sangit Kumar Ragi",
    "role": "Editor-in-Chief",
    "affiliation": "Professor, Department of Political Science · University of Delhi, New Delhi-110007, India",
    "email": "skragi@polscience.du.ac.in"
  },
  {
    "photo": "/uploads/2026/02/Prof-Vipul-Singh.jpg",
    "name": "Prof. Vipul Singh",
    "role": "",
    "affiliation": "Professor, Department of History · University of Delhi, New Delhi-110007, India",
    "email": "vipulsingh.history@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/Prof-Seema-Bawa.webp",
    "name": "Prof. Seema Bawa",
    "role": "",
    "affiliation": "Professor, Department of History · University of Delhi, New Delhi-110007, India",
    "email": "bawaseema@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/Prof-Ajay-Kumar-Ghosh.jpg",
    "name": "Prof. Ajay Kumar Ghosh",
    "role": "",
    "affiliation": "Professor, Department of History, Govt. · Hamidia Arts and Commerce College · Bhopal, Madhya Pradesh, India",
    "email": "kumarghoshajay@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/Prof-Rajiv-Nayan.jpg",
    "name": "Prof. Rajiv Nayan",
    "role": "",
    "affiliation": "Professor, National Mandela Center for Peace and Conflict Resolution · Jamia Millia Islamia, New Delhi, India",
    "email": "rajivnayan@hotmail.com"
  },
  {
    "photo": "/uploads/2026/02/Prof-Manoj-Kamat.jpg",
    "name": "Prof. Manoj S. Kamat",
    "role": "",
    "affiliation": "Professor, Professor and Principal, DCT’s · Srinivassa Sinai Dempo College (Autonomous) · Cujira, Goa, India",
    "email": "mskamat@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/Prof-Suresh-Jondhale.jpg",
    "name": "Prof. Surendra Jhondhale",
    "role": "Retd.",
    "affiliation": "Professor, Department of Civics and Politics · University of Mumbai, India",
    "email": "surenjondhale@yahoo.co.in"
  },
  {
    "photo": "/uploads/2026/02/Prof-Rajesh-kumar-Sharma.jpg",
    "name": "Dr. Rajesh Kumar Sharma",
    "role": "",
    "affiliation": "Department of Political Science · University of Rajasthan, Jaipur, India",
    "email": "rksharma038@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/Prof-Amit_Dholakia.jpeg",
    "name": "Prof. Amit Rajendra Dholakia",
    "role": "",
    "affiliation": "Professor, Department of Political Science · The Maharaja Sayajirao University of Baroda, India",
    "email": "amit.dholakiapolsci@msubaroda.ac.in"
  },
  {
    "photo": "/uploads/2026/02/Prof-Anshuman-Behera.jpeg",
    "name": "Prof. Anshuman Behera",
    "role": "",
    "affiliation": "Professor, School of Conflict and Security Studies · National Institute of Advance Studies (NIAS), Bengaluru, India",
    "email": "beheraisanshuman@gmail.com"
  }
]
export const EDITORIAL_ADVISORY: Person[]   = [
  {
    "photo": "/uploads/2026/02/Dinesh-Singh.jpg",
    "name": "Professor Dinesh Singh",
    "role": "",
    "affiliation": "Former Vice Chancellor, University of Delhi · Vice-Chairman, J&K Higher Education Council",
    "email": "dineshsingh1@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/Rajas.jpg",
    "name": "Professor Rajas Parchure",
    "role": "",
    "affiliation": "Professor, Gokhale Institute of Politics and Economics · Pune–411004, Maharashtra, India",
    "email": "rajasparchure@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/SanjayChaturvedi.jpg",
    "name": "Professor Sanjay Chaturvedi",
    "role": "",
    "affiliation": "Professor, Faculty of Social Sciences · South Asian University · Akbar Bhavan, Chanakyapuri, New Delhi-110021, India",
    "email": "sanjaychaturvedi@sau.int"
  },
  {
    "photo": "/uploads/2026/02/Sanjay-Kumar-1.jpg",
    "name": "Professor Sanjay Kumar",
    "role": "",
    "affiliation": "Former Director, Centre for the Study of · Developing Societies (CSDS) · 29, Rajpur Road, Delhi-110054, India",
    "email": "sanjay@csds.in"
  },
  {
    "photo": "/uploads/2026/02/Ritesh.jpeg",
    "name": "Professor Ritesh Kumar Singh",
    "role": "",
    "affiliation": "Former Dean, Department of Commerce, Delhi · School of Economics · University of Delhi, New Delhi-11007, India",
    "email": "dean@commerce.du.ac.in"
  }
]
export const ASSISTANT_EDITORS: Person[]    = [
  {
    "photo": "/uploads/2026/02/Dr.-Abhishek-Choudhary.jpg",
    "name": "Dr. Abhishek Choudhary",
    "role": "",
    "affiliation": "Assistant Professor · Department of Political Science · University of Delhi, Delhi",
    "email": "achoudhary@polscience.du.ac.in"
  },
  {
    "photo": "/uploads/2026/02/Dr.-Miranda-Das.jpg",
    "name": "Dr. Miranda Das",
    "role": "",
    "affiliation": "Assistant Professor · Department of Political Science · University of Delhi, Delhi",
    "email": "das.jan.miranda@gmail.com"
  },
  {
    "photo": "/uploads/2026/02/Dr.-Koiremba.png",
    "name": "Dr. Koiremba Ningthoujam Singh",
    "role": "",
    "affiliation": "Assistant Professor · Department of Political Science · University of Delhi, Delhi",
    "email": "koirembasingh@yahoo.com"
  }
]
export const EDITORIAL_ASSOCIATES: Person[] = [
  {
    "photo": "/uploads/2026/02/Mr.-Raushan-Thakur.jpeg",
    "name": "Dr. Raushan Thakur",
    "role": "",
    "affiliation": "Assistant Professor (Guest), University of Delhi",
    "email": ""
  },
  {
    "photo": "/uploads/2026/02/WhatsApp-Image-2026-02-11-at-12.09.07-AM.jpeg",
    "name": "Mr. Prateek Kashyap",
    "role": "",
    "affiliation": "Assistant Professor, University of Delhi",
    "email": ""
  },
  {
    "photo": "/uploads/2026/02/WhatsApp-Image-2026-02-09-at-01.06.52-2.jpeg",
    "name": "Ms. Syed Insha",
    "role": "",
    "affiliation": "Research Scholar, University of Delhi",
    "email": ""
  },
  {
    "photo": "/uploads/2026/02/WhatsApp-Image-2026-02-09-at-01.06.52-1.jpeg",
    "name": "Ms. Sandhanee Deka",
    "role": "",
    "affiliation": "Research Scholar, University of Delhi",
    "email": ""
  }
]
export const BOARD_OF_TRUSTEES: Person[]    = [
  {
    "photo": "/uploads/2026/02/Prof-Sangit-Ragi.jpeg",
    "name": "Prof. Sangit Kumar Ragi",
    "role": "",
    "affiliation": "Managing Trustee",
    "email": ""
  },
  {
    "photo": "/uploads/2026/02/WhatsApp-Image-2026-02-11-at-5.42.01-PM.jpeg",
    "name": "Mr Ravi Kishore",
    "role": "",
    "affiliation": "Trustee",
    "email": ""
  }
]

export const VOLUMES: VolumeListEntry[] = [
  {
    "slug": "volume-7-no-1",
    "cover": "/uploads/2026/10/Vol-7-No-1.jpg",
    "label": "Vol. 7 No. 1 (2026)",
    "range": "January - June 2026",
    "month": "June 2026"
  },
  {
    "slug": "volume-6-no-2",
    "cover": "/uploads/2026/02/Vol-6-No-2.jpg",
    "label": "Vol. 6 No. 2 (2025)",
    "range": "July - December 2025",
    "month": "December 2025"
  },
  {
    "slug": "volume-6-no-1",
    "cover": "/uploads/2026/02/Vol-6-No-1.png",
    "label": "Vol. 6 No. 1 (2025)",
    "range": "January - June 2025",
    "month": "January 2025"
  },
  {
    "slug": "volume-5-no-2",
    "cover": "/uploads/2026/02/Vol-5-No-2.png",
    "label": "Vol. 5 No. 2 (2024)",
    "range": "July - December 2024",
    "month": "December 2024"
  },
  {
    "slug": "volume-5-no-1",
    "cover": "/uploads/2026/02/Vol-5-No-1.png",
    "label": "Vol. 5 No. 1 (2024)",
    "range": "January - June 2024",
    "month": "June 2024"
  },
  {
    "slug": "volume-5-no-s-1",
    "cover": "/uploads/2026/02/Vol-5-No-S-1.jpg",
    "label": "Indian Studies Review Volume 5 No. S-1 Special Issue",
    "range": "",
    "month": ""
  },
  {
    "slug": "volume-4-no-2",
    "cover": "/uploads/2026/02/Vol-4-No-2.png",
    "label": "Vol. 4 No. 2 (2023)",
    "range": "July - December 2023",
    "month": "December 2023"
  },
  {
    "slug": "volume-4-no-1",
    "cover": "/uploads/2026/02/Vol-4-No-1.png",
    "label": "Vol. 4 No. 1 (2023)",
    "range": "January - June 2023",
    "month": "January 2023"
  },
  {
    "slug": "volume-3-no-2",
    "cover": "/uploads/2026/02/Vol-3-No-2.png",
    "label": "Vol. 3 No. 2 (2022)",
    "range": "July - December 2022",
    "month": "December 2022"
  },
  {
    "slug": "volume-3-no-1",
    "cover": "/uploads/2026/02/Vol-3-No-1.png",
    "label": "Vol. 3 No. 1 (2022)",
    "range": "January - June 2022",
    "month": "June 2022"
  },
  {
    "slug": "volume-2-no-2",
    "cover": "/uploads/2026/02/Vol-2-No-2.png",
    "label": "Vol. 2 No. 2 (2021)",
    "range": "July - December 2021",
    "month": "December 2021"
  },
  {
    "slug": "volume-2-no-1",
    "cover": "/uploads/2026/02/Vol-2-No-1.png",
    "label": "Vol. 2 No. 1 (2021)",
    "range": "January - June 2021",
    "month": "June 2021"
  },
  {
    "slug": "volume-1-no-2",
    "cover": "/uploads/2026/02/Vol-1-No-2.png",
    "label": "Vol. 1 No. 2 (2020)",
    "range": "July - December 2020",
    "month": "July 2020"
  },
  {
    "slug": "vol-1-no-1-2020",
    "cover": "/uploads/2026/02/Vol-1-No-1.png",
    "label": "Vol. 1 No. 1 (2020)",
    "range": "January - June 2020",
    "month": "January 2020"
  }
]

export const ISSUES: Record<string, Article[]> = {
  "volume-7-no-1": [
    {
      "title": "Incumbency, Welfare and Women’s Voting Behaviour in the 2026 Vidhan Sabha Elections",
      "authors": "Prof. Sanjay Kumar, Vibha Attri & Arindam Kabir",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-1.pdf"
    },
    {
      "title": "Caste to Conversion: Ambedkar’s Reimagining of Buddhism as Navayana",
      "authors": "Dr. Anushree",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-2.pdf"
    },
    {
      "title": "Repositioning Millets in Uttar Pradesh: Agricultural Context and the Policy Response of the Millet Mission",
      "authors": "Dr. Avantika Singh & Dr. Abhishek Choudhary",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-3.pdf"
    },
    {
      "title": "Governing Conflict: Examining India’s Counterinsurgency Strategies and Developmental Paradigm",
      "authors": "Dr. Kamal Kumar & Dr. Neetu Dabas",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-4.pdf"
    },
    {
      "title": "Constitutionalizing Local Governance: A Comparative Assessment of the Sixty-fourth, Seventy-second, and Seventy-third Constitutional Amendments for Panchayati Raj Institutions",
      "authors": "Dr. Loveena Sehra",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-5.pdf"
    },
    {
      "title": "Exploring the Relevance of the Planetary Urbanisation Framework for Sustainable Urban Development in Northeast India: A Study of Census Towns in Assam",
      "authors": "Dr. Sadhna Gupta & Dr. Shailza Singh",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-6.pdf"
    },
    {
      "title": "A Critical Analysis of India's National Education Policy 2020 through the Lens of Ancient Buddhist Pedagogy",
      "authors": "Dr. Krishna Murari",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-7.pdf"
    },
    {
      "title": "State Failure and Breakdown of Order: A Case Study of Yugoslavia",
      "authors": "Dr. Surae Soren",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-8.pdf"
    },
    {
      "title": "Women’s Reservation in India: An Analytical Study",
      "authors": "Dr. Ravi, Dr. Amit Kumar & Dr. Milan",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-9.pdf"
    },
    {
      "title": "Interrogating the “Devil’s Triangle”: India’s Strategic Discourse on the Growing Pakistan–China–Bangladesh Nexus and Policy Responses",
      "authors": "Dr. Suvasish Chakraborty",
      "pdf": "/uploads/2026/10/Vol-7-No-1-Part-10.pdf"
    }
  ],
  "volume-6-no-2": [
    {
      "title": "The Cakkavattisīhanāda Sutta: A Guideline for Good Governance and Rājadhamma",
      "authors": "Krishna Murari",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-1.pdf"
    },
    {
      "title": "Strengthening Democracy and Inclusive Governance in Jammu and Kashmir after Abrogation of Article 370 and 35A",
      "authors": "Dr. Amar Bahadur Shukla and Dr. Priyanka Dutta Chowdhury",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-2-1.pdf"
    },
    {
      "title": "Place-Renaming as a Tool of Political Symbolism and Political Performance: Memory, Identity and Power in Contemporary Uttar Pradesh",
      "authors": "Akanksha Sharma and Archita Sharma",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-3-1.pdf"
    },
    {
      "title": "Caste Census in India: Colonial Roots and Contemporary Debates",
      "authors": "Dr. Prakash Kumar Patel",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-4-1.pdf"
    },
    {
      "title": "From Marketplaces to Ballot Boxes: The Evolution and Strategic Role of Marketing in Modern Politics",
      "authors": "Madhav",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-5-1.pdf"
    },
    {
      "title": "China’s Hydro Hegemony and Strategic Contestation over the Brahmaputra River Basin",
      "authors": "Sailika Chamling and Phairembam Newton Singh",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-6-1.pdf"
    },
    {
      "title": "Gujarat Riots: The True Story, M.D. Deshpande (2022), Second Edition. ISBN: 978-1-4828-4165-7 Partridge India",
      "authors": "Anjani Kumar Rai",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-7-1.pdf"
    },
    {
      "title": "Bharat Rising : Dharma, Democracy, Diplomacy, Utpal Kumar (2024) ISBN: 978-9392209765 Blueone Ink Private Limited",
      "authors": "Kirti Singh",
      "pdf": "/uploads/2026/02/Vol-6-No-2-Part-8.pdf"
    }
  ],
  "volume-6-no-1": [
    {
      "title": "Digital Personal Data Protection Act, 2023: A Critical Analysis",
      "authors": "Samreen Ahmed and Dr. Mohammad Nasir",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-1.pdf"
    },
    {
      "title": "Cold War 2.0 and Espionage",
      "authors": "Dr. Devender Kumar",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-2.pdf"
    },
    {
      "title": "The Ballot and the Brand: A Comparative Analysis of BJP and Congress Campaigns and the Marketing Imperative in Indian Elections",
      "authors": "Madhav",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-3.pdf"
    },
    {
      "title": "Remand Under Bnss: A Comparative Study with Uk & Us Laws",
      "authors": "Prof (Dr) Gunjan Gupta & Dr. Aquib Husain",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-4.pdf"
    },
    {
      "title": "Vedānta as the Basic Culture of India Through the Lens of Chakravarti Rajagopalachari",
      "authors": "Abhijeet Kumar",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-5.pdf"
    },
    {
      "title": "Availability and Accessibility of Health Protection Policies in Jammu and Kashmir: An Analysis of Ayushman Bharat Pradhan Mantri Jan Arogya Yojana",
      "authors": "Dr. Mushtaq Ahmad Malla",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-6.pdf"
    },
    {
      "title": "Oman and India: Retracing Historical Voyages and Forging New Strategic connectivity",
      "authors": "Dr. Tsupokyemla",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-7.pdf"
    },
    {
      "title": "Tackling Cyber Crime Against Women in India: An Effort to Build a Resilient Society",
      "authors": "Dr Shalini Prasad & Dr Abhay Kumar",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-8.pdf"
    },
    {
      "title": "The new icon: savarkar and the facts, Arun shourie, Penguin viking, new Delhi, isbn: 9780143474333, rs. 659, pp. 560, 2025",
      "authors": "Parul singh",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-9.pdf"
    },
    {
      "title": "India's Experiment with Democracy: The Life of a Nation through its election, s.y. quraishi, HarperCollins india, isbn: 9789356993648, rs. 699, pp. 600, 2023",
      "authors": "subarna banerjee",
      "pdf": "/uploads/2026/02/Vol-6-No-1-Part-10.pdf"
    }
  ],
  "volume-5-no-s-1": [
    {
      "title": "Contours of India’s Culture-based Foreign Policy in South and Southeast Asia",
      "authors": "Prof. Sangit Kumar Ragi, Dr. Abhishek Choudhary and Dr. Ningthoujam Koiremba Singh",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-1.pdf"
    },
    {
      "title": "Syama Prasad Mookerjee’s role in Indian Foreign Policy: A Case Study of the Korean War",
      "authors": "Kuri Sravan Kumar",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-2.pdf"
    },
    {
      "title": "India's Soft Power Diplomacy in the Maldives: Cultural and Strategic Engagement amidst Geopolitical Challenges",
      "authors": "Rajani Mol, Abdul Wasi Popalzay, Musssaib Rasool Mir",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-3.pdf"
    },
    {
      "title": "Bridging Cultures Beyond Borders: The Cultural Landscape of Northeast India through the Lens of Act East Policy",
      "authors": "Mudang Onju, Naina Lahon, Rehfi Mele, Dr. Padi Hana",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-4.pdf"
    },
    {
      "title": "Diaspora: A Soft Power Stakeholder in India’s Southeast Asian Foreign Policy",
      "authors": "Dr. Ningthoujam Koiremba Singh, Tayenjam Priyokumar Singh",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-5.pdf"
    },
    {
      "title": "From Spice Trade to Modern Diplomacy with the Southeast through the Lens of Sangam Literature",
      "authors": "Sibi S",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-6.pdf"
    },
    {
      "title": "Engaging in the Indo-Pacific as a Civilizational State: A Study of Contemporary Indian Statecraft",
      "authors": "Amruta Karambelkar",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-7.pdf"
    },
    {
      "title": "Deconstructing India’s Soft Power Trajectory in South Asia: Mapping the Case of Bollywood",
      "authors": "Dr. Abhishek Choudhary, Aiman Urooj & Dr. Avantika Singh",
      "pdf": "/uploads/2026/02/Vol-5-No-S-1-Part-8.pdf"
    }
  ],
  "volume-5-no-2": [
    {
      "title": "2024 Lok Sabha Election Verdict",
      "authors": "Prof Sanjay Kumar",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-1.pdf"
    },
    {
      "title": "Electoral Outcome of Lok Sabha Elections in Madhya Pradesh 2024: Explanation of Continuous Ascendance of BJP",
      "authors": "Prof. Yatindra Singh Sisodiar",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-2.pdf"
    },
    {
      "title": "Elections in Chandigarh Union Territory: A Longer View with Focus on the 2024 Elections",
      "authors": "Prof. Ashutosh Kumar",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-3.pdf"
    },
    {
      "title": "An Historical Account of Political Sloganeering in India",
      "authors": "Dr. Raushan Thakur",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-4.pdf"
    },
    {
      "title": "BJP Manifestos: What Changed between 2014 and 2024?",
      "authors": "Prof. Sangit Kumar Ragi",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-5.pdf"
    },
    {
      "title": "Digital Spaces and Political Mobilisation",
      "authors": "Prof. Manisha Tripathy Pandey and Niharika Parasharr",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-6.pdf"
    },
    {
      "title": "From Booth to Bot: Indian General Elections of 2024 and Artificial Intelligence",
      "authors": "Sandhanee Deka and Syed Insha",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-7.pdf"
    },
    {
      "title": "Role of Regional Issues in National Party Manifestos: Review of Indian General Elections 2024",
      "authors": "Kumara S",
      "pdf": "/uploads/2026/02/Vol-5-No-2-Part-8.pdf"
    }
  ],
  "volume-5-no-1": [
    {
      "title": "Study of Declining Child Sex Ratio and Girl Child discrimination in Select Districts of Uttar Pradesh and Haryana – Key findings and Policy Recommendations",
      "authors": "Prof. Bijayalaxmi Nanda and Dr. Nupur Rayy",
      "pdf": "/uploads/2026/02/Vol-5-No-1-Part-1.pdf"
    },
    {
      "title": "MGNREGS and The Integrated Process of Financial Inclusion: Causes Behind The Variance of Expansion Among The Indian States",
      "authors": "Dr. Tithi Bose",
      "pdf": "/uploads/2026/02/Vol-5-No-1-Part-2.pdf"
    },
    {
      "title": "Farmers’ Income and Indebtedness in India: An Inter-State Analysis",
      "authors": "Sheetal and Dr Subhash",
      "pdf": "/uploads/2026/02/Vol-5-No-1-Part-3.pdf"
    },
    {
      "title": "Halal Economy and Assertive Islam: A Critical Study",
      "authors": "Prof. Sangit Kumar Ragi and Dr. Abhishek Choudhary",
      "pdf": "/uploads/2026/02/Vol-5-No-1-Part-4.pdf"
    },
    {
      "title": "The Cultural Connect – Glimpses from India and Laos",
      "authors": "Prof. Vandana Mishra",
      "pdf": "/uploads/2026/02/Vol-5-No-1-Part-5.pdf"
    },
    {
      "title": "India and Climate Change Negotiations: A Critical Geo-Political Analysis",
      "authors": "Prof. Manoj Sinha",
      "pdf": "/uploads/2026/02/Vol-5-No-1-Part-6.pdf"
    },
    {
      "title": "Trubowitz, P., & Burgoon, B. (2023). 265 pages. Geopolitics and Democracy: The Western Liberal Order from Foundation to Fracture. New York: Oxford University Press.",
      "authors": "Anjali Kumari",
      "pdf": ""
    },
    {
      "title": "“HOMELAND INSECURITIES: AUTONOMY, CONFLICT AND MIGRATION IN ASSAM” BY SANJAY BARBORA, OXFORD UNIVERSITY PRESS, 2022, ISBN: 978–0–19–285532–9",
      "authors": "Sandhanee Deka",
      "pdf": "/uploads/2026/02/Vol-5-No-1-Part-8.pdf"
    }
  ],
  "volume-4-no-2": [
    {
      "title": "Gender Stereotypes in Judiciary: Decisions in the Shadow of Sexism",
      "authors": "Dr. Amreen Ameer Mailanchi & Prof (Dr.) S. Vinod Kumar",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-1.pdf"
    },
    {
      "title": "Sanskrit in Post Colonial India: A Study from 2014-2023",
      "authors": "Dr. Mithila Bagai",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-2.pdf"
    },
    {
      "title": "Indianisation of the Indian Legal System: Mapping the Relevance of the Ancient Indian Jurisprudence",
      "authors": "Dr. Mohammad Nasir & Samreen Ahmed",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-3.pdf"
    },
    {
      "title": "Hydropolitics in South Asia: Unravelling Afghanistan's Hydro-Political Challenges and Regional Cooperation",
      "authors": "Pintu Kumar Mahla & Shivendra Shandilya",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-4.pdf"
    },
    {
      "title": "Indigenous Knowledge, Insights and Strategies of Disaster Risk Reduction and Resilience of Coastal Blocks of Purba Medinipur District, West Bengal: The Paradigm Shift from Vulnerability to Strength",
      "authors": "Dr. Manishree Mondal, Chayon Chakraborty, Puja Karmakar & Dr. S.K. Mustak",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-5.pdf"
    },
    {
      "title": "Quadrilateral Security Dialogue; the Great Democratic Wall to Siege the Great Firewall",
      "authors": "Dr. Kalpana S. Agrahari",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-6.pdf"
    },
    {
      "title": "Gender Mainstreaming in International Relations: A Case of Swedish Feminist Foreign Policy",
      "authors": "Annasab Shivaling Mirje & Dr. Girija K.S.",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-7.pdf"
    },
    {
      "title": "“Hindu Sociology” by Benoy Kumar Sarkar, Rawat Publications, Indian Reprint, 2019. ISBN: 978-81-316-1096-1",
      "authors": "Syed Insha",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-8.pdf"
    },
    {
      "title": "Maya, Modi, Azad: Dalit Politics in the Time of Hindutva by Sudha Pai and Sajjan Kumar, HarperCollins, 2023. ISBN-13: 978-9356296893",
      "authors": "Survesh Pratap Singh",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-9.pdf"
    },
    {
      "title": "Ethnic Conflict and Civic Life: Hindus and Muslims in India, Varshney, A. (2002), New Haven and London: Yale University Press",
      "authors": "Vineeta Singh",
      "pdf": "/uploads/2026/02/Vol-4-No-2-Part-10.pdf"
    }
  ],
  "volume-4-no-1": [
    {
      "title": "The Bhartiya Janata Party in the States of Northeast India",
      "authors": "Rajesh Dev",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-1.pdf"
    },
    {
      "title": "Kashmir Pandits: Migration, Homelessness and Resettlement",
      "authors": "Atanu Mohapatra & Chandan K. Pandal",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-2.pdf"
    },
    {
      "title": "COVID 19 Pandemic: Reinforcing the Need for Gender Sensitive Policy Framework",
      "authors": "Angira Sen",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-3.pdf"
    },
    {
      "title": "China’s Engagement with the Island States of East Africa in the Western Indian Ocean: A Geo-economic Perspective",
      "authors": "Raghvendra Kumar",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-4.pdf"
    },
    {
      "title": "New Age Banking and Its Socio-Economic Implications",
      "authors": "Deepa Kamra, Samir & Neeraj Gupta",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-5.pdf"
    },
    {
      "title": "The Tight Rope Walk between the geo Economic Implications of Trans Pacific Partnership and Regional Comprehensive Economic Partnership: India Responds",
      "authors": "Manan Dwivedi & Gayatri Dixit",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-6.pdf"
    },
    {
      "title": "A Critical Re-engagement with Traditions: Women, Agriculture and Agroecology in India",
      "authors": "Pushpa Singh",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-7.pdf"
    },
    {
      "title": "Johansson, A, & Vinthagen, S. (2020). Conceptualizing Everyday Resistance: A transdisciplinary Approach. Routledge: New York and London. 348 pp. Rs. 4027.",
      "authors": "Dr. Vaishali",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-8.pdf"
    },
    {
      "title": "Yadan, B. (2022). The Rise of the BJP: The making of the world’s Largest Political Party. Penguin. India. 334 pp. Rs. 457.",
      "authors": "Rupesh Ranjan",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-9.pdf"
    },
    {
      "title": "Geiselberger, H. (2017). The Great Regression. Polity: Britain. 220 pp. Rs. 1232.",
      "authors": "Monika",
      "pdf": "/uploads/2026/02/Vol-4-No-1-Part-10.pdf"
    }
  ],
  "volume-3-no-2": [
    {
      "title": "Media Consumption in the Digital Age: A Study on the Cultural Reception of Over-the-top (OTT) Video Streaming Platforms in India",
      "authors": "Ronie Thomas, Sony Jalarajan Raj & Adith K. Suresh",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-1.pdf"
    },
    {
      "title": "Dara Shukoh: The Lost Lineage of Universalism",
      "authors": "Neena Bansal",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-2.pdf"
    },
    {
      "title": "What Fueled the Russia–Ukraine War?",
      "authors": "Hari Mohan Sharma & Hari K. Sharma",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-3.pdf"
    },
    {
      "title": "Strategic Significance of Sri Lanka in India’s Indian Ocean Approach",
      "authors": "Debasish Nandy & Alik Naha",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-4.pdf"
    },
    {
      "title": "Understanding Baloch: Genesis and Continuum of their grievances",
      "authors": "Bipin Kr. Tiwary & Akansha",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-5.pdf"
    },
    {
      "title": "A decade of Dragon’s Debt & Trap Initiative in South Asia",
      "authors": "Saurabha",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-6.pdf"
    },
    {
      "title": "India-China Border Dispute and the Hanging Future of South Asian Region",
      "authors": "Aparna",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-7.pdf"
    },
    {
      "title": "Hasan, Z. (2009-19). Ideology and Organization in Indian Politics: Polarization and the Growing Crisis of the Congress Party, New Delhi: Oxford University Press, 2022, 224pp. Rs. 1495.",
      "authors": "Akanksha Sharma",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-7.pdf"
    },
    {
      "title": "Ray, N.(2021) India and Africa: The Road Ahead by, New Delhi, Indian Council of World Affairs, ₹918",
      "authors": "Banditarani Behera",
      "pdf": "/uploads/2026/02/Vol-3-No-2-Part-8.pdf"
    }
  ],
  "volume-3-no-1": [
    {
      "title": "Tablighi Jamaat: The Fountainhead of Global Extremism",
      "authors": "Mahesh Ranjan Debata",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-1.pdf"
    },
    {
      "title": "Not so Social Media: Theoretical Insights into the evolution of the Social Media as a tool of Information Warfare",
      "authors": "Contribution of Indian Diaspora in Singapore during India’s Freedom Struggle",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-2.pdf"
    },
    {
      "title": "From Drivers of Economy to Forgotten Indian Citizens: Addressing the Social Welfare Rights of Migrant Workers",
      "authors": "Anuranjita Wadhwa",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-3.pdf"
    },
    {
      "title": "Rural Non-Farm Sector Development and Poverty Reduction in Bangladesh",
      "authors": "Biswajit Choudhury",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-4.pdf"
    },
    {
      "title": "Menstrual Health Management: Knowledge and Practices in Rural Kaushambi District, India",
      "authors": "Anjali Yadav, Arpana Pandey & Chanchal",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-5.pdf"
    },
    {
      "title": "Gendering Politics: Explorations through the Framework of Political Representation, Democratisation and Peace Processes",
      "authors": "Pushpa Singh & Chetna Sharma",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-6.pdf"
    },
    {
      "title": "Environmental Justice Perspective on Indian Forest Laws: Decolonizing Forest Governance",
      "authors": "Kamal Kumar",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-7.pdf"
    },
    {
      "title": "Geopolitics in Central Asian Region: Implications for India",
      "authors": "Satyam Singh & Neeta Rani",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-8.pdf"
    },
    {
      "title": "Haagh, L. (2019). The case for universal basic income. India: Polity. 140 pp. Rs. 1027.",
      "authors": "Rishabh Raj",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-9.pdf"
    },
    {
      "title": "Chandra, Y. (2021). The Tale of the Horse: A History of India On Horseback: Picador India. 336 pp. Rs. 464.",
      "authors": "Dr. Deepak Solanki",
      "pdf": "/uploads/2026/02/Vol-3-No-1-Part-10.pdf"
    }
  ],
  "volume-2-no-2": [
    {
      "title": "Contribution of Indian Diaspora in Singapore during India’s Freedom Struggle",
      "authors": "Atanu Mohpatra and Aparna Tripathi",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-1.pdf"
    },
    {
      "title": "The Subnational Politics of Dispossession: How Nepotism Stymied Development and Sparked Resistance in Polepally, Andhra Pradesh",
      "authors": "Raman Kumar Apsingikar & David Hundt",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-2.pdf"
    },
    {
      "title": "A Study of the Military Strategy and Leadership of Ahom Commander Lachit Barphukan",
      "authors": "Pranav Kumar & Vandana Mishra",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-3.pdf"
    },
    {
      "title": "Urban Politics: A Case Study of Delhi",
      "authors": "Hari Mohan Sharma & Hari K. Sharma",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-4.pdf"
    },
    {
      "title": "The Political Significance of Saliha Satyagraha",
      "authors": "Kamalakanta Roul",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-5.pdf"
    },
    {
      "title": "China-Russia Relations in the Post-Cold War Period: Revitalization of Brotherhood or Friend of Compulsion?",
      "authors": "Shiv Poojan Pathak",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-6.pdf"
    },
    {
      "title": "N Chandrasekaran, N, &, Purushothaman, R. (2019). Bridgital Nation Solving Technology’s People Problem. Penguin Random House Year. 344pp. Rs. 639.",
      "authors": "Mohammad Nasir",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-7.pdf"
    },
    {
      "title": "Bluhm, K . Pikhan ,G. Stypinkska, J., & Wierzcholska, A. (2021) Gender and Power in Eastern Europe : Changing Concepts of Femininity and Masculinity in Power Relations. Springer, 269pp. Rs. 11,196.",
      "authors": "Khyati Pal",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-8.pdf"
    },
    {
      "title": "Shani, S. (2021). Indigenous Elites in Africa: The Case of Kenya’s Maasai. New York. USA: Routledge. 216 pp. Rs. 12,012.",
      "authors": "Divya Kunwar",
      "pdf": "/uploads/2026/02/Vol-2-No-2-Part-9.pdf"
    }
  ],
  "volume-2-no-1": [
    {
      "title": "India’s Security Response to the Maoist Insurgency",
      "authors": "Anshuman Behera",
      "pdf": "/uploads/2026/02/Vol-2-No-1-Part-1.pdf"
    },
    {
      "title": "Need for a New Definition of War in Indian University Curriculum: A Content Analysis of International Relations Syllabi of Higher Education Institutions",
      "authors": "Amardeep Singh",
      "pdf": "/uploads/2026/02/Vol-2-No-1-Part-2.pdf"
    },
    {
      "title": "India’s Foreign Policy through a Gender Lens: India and Afghanistan Relations",
      "authors": "Rashmi Gopi",
      "pdf": "/uploads/2026/02/Vol-2-No-1-Part-3.pdf"
    },
    {
      "title": "India’s Northeast: ‘Gateway’ to Southeast Asia?",
      "authors": "Alik Nahai",
      "pdf": "/uploads/2026/02/Vol-2-No-1-Part-4.pdf"
    },
    {
      "title": "Covid-19 Crisis and Reverse Migration in India",
      "authors": "Ashutosh Trivedii",
      "pdf": "/uploads/2026/02/Vol-2-No-1-Part-5.pdf"
    },
    {
      "title": "Raja Sekhar Vundru’s, ‘Ambedkar, Gandhi and Patel The Making of India’s Electoral System’. Bloomsbury. 2017 .200pp.Rs.499.",
      "authors": "JAGANNATH KUMAR KASHYAP",
      "pdf": "/uploads/2026/02/Vol-2-No-1-Part-6.pdf"
    },
    {
      "title": "Malini Sur: Jungle Passports: Fences, Mobility, and Citizenship at the Northeast India-Bangladesh Border. Philadelphia : University of Pennsylvania. 2021. 248 pp. Rs. 2,252.",
      "authors": "Ashwati C. K, Dr. Rajeesh CS",
      "pdf": "/uploads/2026/02/Vol-2-No-1-Part-7.pdf"
    }
  ],
  "volume-1-no-2": [
    {
      "title": "India’s Defense Strategy: Lessons from and for China",
      "authors": "Sunil Sondhi",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-1.pdf"
    },
    {
      "title": "Illegal Immigration in Assam and Indian Security Concerns in North-East Region",
      "authors": "RAJNEESH KUMAR GUPTA & RAJ KUMAR",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-2.pdf"
    },
    {
      "title": "Quadrilateral Security Dialogue and Maritime Security: An Indian Perspective",
      "authors": "SANJAY PRADHAN",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-3.pdf"
    },
    {
      "title": "Queer (Diaspora), Identity and Governance: A Theoretical Analysis",
      "authors": "SIBA SANKAR MOHANTY & M. GEETA",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-4.pdf"
    },
    {
      "title": "Character Education through Religious Values: An Analysis",
      "authors": "SUSHIL KUMAR TIWARI",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-5.pdf"
    },
    {
      "title": "The Struggle for democracy in Pakistan",
      "authors": "VEENA KUKREJA",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-6.pdf"
    },
    {
      "title": "Jaishankar, S. (2020). The India Way: Strategies for an Uncertain World. New Delhi: Harper Collins Publishers India, 240 pages.",
      "authors": "Smriti Shukla",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-7.pdf"
    },
    {
      "title": "David Brewster, (Ed.) (2018). India and China at Sea: Competition for Naval Dominance in the Indian Ocean. New Delhi: Oxford University Press, pp. 278",
      "authors": "Raghvendra Kumar",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-8.pdf"
    },
    {
      "title": "Sinha, S. (2020). The years that changed India: Vajpayee. India: Penguin Random House, pp. 357.",
      "authors": "Ashna Monga",
      "pdf": "/uploads/2026/02/Vol-1-No-2-Part-9.pdf"
    }
  ],
  "vol-1-no-1-2020": [
    {
      "title": "India’s Central Asia “Push” under Narendra Modi Government",
      "authors": "MAHESH RANJAN DEBATA",
      "pdf": "/uploads/2026/02/Vol-1-No-1-Part-1.pdf"
    },
    {
      "title": "Liberal-Idealist Tradition in the Non-Western World: The Study of Vasudaiva Kutumbakum and Ubuntu",
      "authors": "SANDIPANI DASH",
      "pdf": "/uploads/2026/02/Vol-1-No-1-Part-2.pdf"
    },
    {
      "title": "Anaj Bank: An Attempt to Undo Hunger in Remote Areas",
      "authors": "AVANTIKA SINGH",
      "pdf": "/uploads/2026/02/Vol-1-No-1-Part-3.pdf"
    },
    {
      "title": "Narrative of Political Violence in Iraq: Some Observation",
      "authors": "MANAN DIWID",
      "pdf": "/uploads/2026/02/Vol-1-No-1-Part-4.pdf"
    },
    {
      "title": "Understanding ASEAN-China Conflict Prevention Measures: A Case Study of South China Sea.",
      "authors": "CHANDER SHEKHAR",
      "pdf": "/uploads/2026/02/Vol-1-No-1-Part-5.pdf"
    },
    {
      "title": "Sharma, R. (2019). Democracy on the Road. New Delhi. India: Penguin 280 Pages.",
      "authors": "Pawan Singh",
      "pdf": "/uploads/2026/02/Vol-1-No-1-Part-6.pdf"
    },
    {
      "title": "Tiwari, R.K. (2019). Political Parties, Party Manifestos and Election in India, 1909-2014. South Asia Edition: Routledge.",
      "authors": "Raushan Thakur",
      "pdf": "/uploads/2026/02/Vol-1-No-1-Part-7.pdf"
    }
  ],
  "vol-62": []
}

export function getIssue(slug: string): Article[] {
    return ISSUES[slug] ?? []
}

export function issueFullPdf(v: VolumeListEntry): string {
    const m = v.cover.match(/^(.*)\.(jpe?g|png|webp)$/i)
    return m ? `${m[1]}.pdf` : ''
}

export const CONTACT: ContactInfo | null = {
  "name": "Prof. Sangit Kumar Ragi",
  "role": "Editor-in-Chief, Indian Studies Review,",
  "address": "Room No- 220, Department of Political Science,\nFaculty of Social Science, University of Delhi, Delhi -110007",
  "emails": [
    "indianstudiesreview@gmail.com",
    "cspgindia@gmail.com"
  ],
  "phone": "+91-9810960009"
}

export const HOME_BLOCKS: HomeBlock[] = [
  {
    "heading": "CENTRE FOR STUDY OF POLITICS AND GOVERNANCE",
    "body": "Centre for the Study of Politics and Governance is a Delhi-based think tank established in 2019 through the collaboration of intellectuals and professionals from diverse disciplines. The Centre is dedicated to fostering interdisciplinary dialogue and innovative thinking on public policy issues spanning social, political, economic, legal, scientific, and environmental domains."
  },
  {
    "heading": "INDIAN STUDIES REVIEW",
    "body": ""
  },
  {
    "heading": "Journal of Centre for Study of Politics and Governance",
    "body": "Indian Studies Review (ISR) is a prestigious academic journal published by the Centre for Study of Politics and Governance. The journal covers a wide range of areas within the social sciences, including sociology, anthropology, economics, political science, history, and related interdisciplinary fields. Since its establishment in 2019, the journal has been committed to promoting high-quality research and scholarly discourse. ISR is published biannually (January and July), both online and in print, from Delhi."
  },
  {
    "heading": "For Authors",
    "body": ""
  },
  {
    "heading": "Everything you need to know about submitting your research to ISR",
    "body": ""
  },
  {
    "heading": "Frequently Asked Questions",
    "body": ""
  },
  {
    "heading": "Everything you need to know about submitting your research to ISR",
    "body": ""
  },
  {
    "heading": "Contact Us",
    "body": ""
  },
  {
    "heading": "Get in touch with us",
    "body": ""
  }
]

export const FAQS: FAQ[] = [
  {
    "q": "Can I submit my manuscript even after the submission window is closed?",
    "a": "Yes. The journal welcomes manuscripts throughout the year — submissions are open 365 days a year, with no deadline. You may submit at any time; your manuscript will simply be considered for the next available issue.</div>"
  },
  {
    "q": "Is a plagiarism report mandatory for manuscript submission?",
    "a": "Yes, manuscripts must include a plagiarism report from a recognized tool.</div>"
  },
  {
    "q": "What are the accepted plagiarism detection tools?",
    "a": "The journal accepts plagiarism reports generated using reputable and widely recognized tools such as <strong>iThenticate, Turnitin, Urkund, and DrillBit</strong>. These tools are trusted within academic and scholarly communities for their accuracy and effectiveness in detecting instances of overlap or duplication. Authors are encouraged to use these tools to ensure their manuscripts meet the journal's originality standards before submission.</div>"
  },
  {
    "q": "What is the acceptable level of similarity?",
    "a": "The similarity index must be less than or equal to <strong>10%</strong> (excluding references and quotations).</div>"
  },
  {
    "q": "What is the ISSN of the journal?",
    "a": "The journal is identified with the following ISSNs: <ul> <li>Print ISSN: 2583-004X</li> <li>Online ISSN: 2582-7154</li> </ul> These can be verified on the official ISSN portal at <a href=\"#\">ISSN Verification</a>. The journal has recently been assigned an online ISSN, reflecting its expansion into digital publishing. </div>"
  },
  {
    "q": "Is the journal UGC-CARE listed?",
    "a": "Yes journal was earlier part of UGC care list before UGC discontinued this category altogether. Presently the journal continues to be well acclaimed peer reviewed and referred journal.</div>"
  },
  {
    "q": "Is the journal published in print or online?",
    "a": "The journal is primarily published in print format. However, we also maintain a robust online presence, ensuring broader accessibility to its content for readers and authors globally.</div>"
  },
  {
    "q": "Are there any submission charges?",
    "a": "Currently, there are no submission charges for authors submitting manuscripts to the journal.</div>"
  },
  {
    "q": "Does the journal collaborate with conference organizers?",
    "a": "Yes, the journal does collaborate with conference organizers. Interested, may contact through designated contact details available on the website.</div>"
  },
  {
    "q": "Are there any Article Processing Charges (APC)?",
    "a": "Yes, an Article Processing Charge (APC) is applicable for accepted manuscripts. This fee covers publication costs and ensures that the article is freely available online as open access. Details about the APC are available on the website.</div>"
  },
  {
    "q": "Do you provide DOIs for published manuscripts?",
    "a": "No we do not provide doi as of now. Any update in this regard will get reflected on the website.</div>"
  },
  {
    "q": "Does the Journal accept submission even after the submission window is closed?",
    "a": "No, We do not accept manuscripts after the submission window is closed.</div>"
  },
  {
    "q": "How do I stay updated about submission windows or announcements?",
    "a": "Announcements are regularly updated on the journal's website.</div>"
  },
  {
    "q": "Do you provide a certificate or hard copy for authors after publication?",
    "a": "No, certificates are not routinely provided. However, the editorial board may consider such requests on a case-by-case basis.</div>"
  },
  {
    "q": "I need my paper to be published in a backdated issue. Can you accommodate this?",
    "a": "No, the journal does not accommodate requests to publish papers in backdated issues. This practice is considered unethical and goes against the principles of transparency and integrity upheld by the journal. All articles are published in the issue corresponding to their acceptance date following the peer review process. Adhering to this policy ensures the credibility of the journal and maintains its commitment to ethical publishing standards.</div>"
  },
  {
    "q": "Why are my mails not answered?",
    "a": "The journal strives to respond to all queries promptly. However, delays may occur due to a large volume of emails being received by Journal office. We recommend checking the Frequently Asked Questions (FAQ) section on our website, as most common queries are addressed there. Additionally, please note that requests for publication based on personal or professional considerations are not encouraged, as the journal's decisions are guided by the quality and relevance of the manuscript.</div>"
  },
  {
    "q": "Where can I check the status of my manuscript?",
    "a": "Authors can track their manuscript status from the dashboard on the submission portal of our website.</div>"
  },
  {
    "q": "What type of peer review does the journal use?",
    "a": "The journal follows a double-blind peer review process, ensuring anonymity for both authors and reviewers to maintain impartiality and fairness in evaluations.</div>"
  },
  {
    "q": "How many days does the reviewer take to review a paper?",
    "a": "Reviewers are typically given 30 working days to provide feedback.</div>"
  },
  {
    "q": "What happens if a reviewer does not provide a review in time?",
    "a": "The editorial team will reassign the manuscript to another reviewer to avoid delays.</div>"
  },
  {
    "q": "How are reviewers selected?",
    "a": "Reviewers are carefully selected based on their expertise in the manuscript's subject area, ensuring a thorough and informed evaluation of submissions.</div>"
  },
  {
    "q": "Can I suggest reviewers?",
    "a": "Yes, authors may suggest reviewers by sending a profile of the reviewer to the Journal office. However, the editorial board retains the final decision on the selection of reviewers to ensure an unbiased review process.</div>"
  },
  {
    "q": "Does the journal prioritize PhD scholars' manuscripts over others?",
    "a": "No, the journal evaluates all manuscripts solely based on their academic merit, originality, and adherence to the journal's guidelines. Each submission is assessed through a rigorous peer-review process, where factors such as the research question's clarity, methodological rigor, quality of data and analysis, and the overall contribution to the field are prioritized.</div>"
  },
  {
    "q": "Does the journal publish in accelerated mode?",
    "a": "No, the journal does not offer an accelerated or expedited publication option. Each manuscript undergoes a comprehensive and structured editorial and peer-review process to ensure the highest standards of quality and academic rigor.</div>"
  },
  {
    "q": "If my manuscript is declined, can I resubmit it?",
    "a": "Declined manuscripts cannot be reconsidered for the same issue. However, authors may resubmit significantly revised manuscripts for consideration in subsequent issues. Resubmissions will be treated as new submissions and evaluated accordingly.</div>"
  },
  {
    "q": "What factors are considered when accepting or declining a manuscript?",
    "a": "At the Indian Studies review(ISR), the acceptance or decline of manuscripts is based on a rigorous evaluation process that includes several key factors: <ul> <li><strong>Initial Compliance Check:</strong> Manuscripts are reviewed to ensure they meet the submission guidelines, including formatting, word count, plagiarism thresholds, and ethical standards. Submissions that fail to meet these criteria may be declined during the initial screening.</li> <li><strong>Plagiarism and Ethical Standards:</strong> Manuscripts found to contain plagiarized content or ethical concerns related to the research will be rejected outright.</li> <li><strong>Scope and Relevance:</strong> The manuscript must align with the journal's objectives and be of interest to our readership. Manuscripts that fall outside the scope or are not relevant to our audience will not be considered for publication.</li> <li><strong>Content Variety and Balance:</strong> The journal strives to ensure a diverse and balanced selection of articles in each issue. Even if well-written, manuscripts may be declined if similar topics have been accepted. This helps maintain a comprehensive collection covering a wide range of subjects.</li> </ul> A declined submission does not necessarily reflect the quality of the manuscript. Instead, it may be due to alignment, diversity, or space considerations. Authors are encouraged to review submission guidelines and consider these factors when preparing manuscripts for future submissions. </div>"
  },
  {
    "q": "How do I submit my manuscript?",
    "a": "Authors can upload their manuscripts on the website during the submission window, which typically opens in the 1st or 2nd week half yearly. Updates will be announced on the journal’s website.</div>"
  },
  {
    "q": "Is manuscript submission accepted through email?",
    "a": "No, manuscript submissions are not accepted via email. To ensure a streamlined and organized submission process, all manuscripts must be submitted through the journal's official online submission system. This system is designed to manage submissions efficiently, track the review process, and maintain transparency for both authors and the editorial team.</div>"
  },
  {
    "q": "Are there any specific fields of study for submissions?",
    "a": "Yes, the journal accepts submissions in the following fields: <ul> <li>Economics, Political Economy, Commerce, Management</li> <li>Anthropology, Sociology, Social Work, History, Archaeology</li> <li>Geography, Environmental Studies, Sustainable Development, Area Studies</li> <li>Political Science, Public Policy, Law, International Relations</li> <li>Language Studies, Cultural Studies, Media and Communication, Library Science</li> <li>Education, Health, Psychology, Philosophy, Social Exclusion, Gender Studies</li> <li>Other Interdisciplinary Studies</li> </ul> The journal encourages scholars to submit manuscripts in interdisciplinary areas of high quality, supported by methodological rigor and empirical evidence. </div>"
  },
  {
    "q": "Can I submit multiple papers for a single issue?",
    "a": "While you can submit multiple papers, we strongly recommend limiting submissions to one paper per issue. As we publish only one paper of an author in an issue.</div>"
  },
  {
    "q": "Can the journal publish two papers of the same author?",
    "a": "No, the journal does not publish more than one paper from the same author in a single issue.</div>"
  },
  {
    "q": "Can I publish articles in two subsequent issues?",
    "a": "No, As per our policy, Manuscripts from the same author/co-author will not be published in three consecutive issues to ensure opportunities for a diverse range of authors. Any exceptions to this policy will be at the discretion of the editorial board, whose decision will be final.</div>"
  },
  {
    "q": "What happens if the manuscript does not follow the journal template?",
    "a": "Manuscripts that do not adhere to the journal's template will be declined.</div>"
  }
]
